import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Fetch from '@/utils/Fetch';
import { createFileRoute } from '@tanstack/react-router'

function OAuthQBO() {

    const router = useRouter();
    const [responseMessage, setResponseMessage] = useState("Something went wrong");

    useEffect(() => {
        if (!router.isReady) return;

        const { code, state, realmId } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

        Fetch.post({
            url: "/Integration/OAuthQBO",
            params: { code, state, realmId }
        }).then((result: any) => {
            if (result?.success) {
                setResponseMessage("Successful authorisation, page should close automatically");
                setTimeout(() => {
                    (window as any).returnValue = true;
                    window.close();
                }, 10);
            } else {
                setResponseMessage(result?.errorMessage || "Something went wrong");
            }
        });
    }, [router.isReady]);

    return (
        <div className="manage-container">
            <h3>{responseMessage}</h3>
        </div>
    );
}

export default OAuthQBO;

export const Route = createFileRoute('/_authenticated/settings/integration/oauthqbo')({ component: OAuthQBO })
